import { Box } from '@mui/material';
import { Loading, TabbedForm, TabbedFormProps, useRecordContext } from 'react-admin';

import FormToolbar from 'src/components/FormToolbar';
import type { CraftAdminPermission } from 'src/types';
import { usePermissions } from 'src/hooks';

interface DeleteOptionsProps {
  hideDeleteButton?: boolean;
  deletePermission: CraftAdminPermission;
  dialogContent?: React.ReactNode;
  dialogTitle?: string;
  onConfirmDelete?: () => void;
}
interface CraftTabbedFormProps extends TabbedFormProps {
  formType: 'create' | 'edit'; // TODO: would be better to get this context from React-Admin
  deleteOptions?: DeleteOptionsProps;
}

export const CraftTabbedForm = (props: CraftTabbedFormProps) => {
  const { formType: viewType, deleteOptions, ...baseProps } = props;
  const { permissions } = usePermissions();
  const record = useRecordContext();

  const resourceIsDeletedOrArchived = !!record?.deleted_at || !!record?.archived_at;

  const showDeleteButton =
    viewType === 'edit' &&
    !!record &&
    !deleteOptions?.hideDeleteButton &&
    (!deleteOptions?.deletePermission || permissions.has(deleteOptions?.deletePermission)) &&
    !resourceIsDeletedOrArchived;

  if (resourceIsDeletedOrArchived) baseProps.disabled = true;

  baseProps.toolbar ??= (
    <FormToolbar
      disableSave={!!baseProps.disabled}
      deleteOptions={{
        showDeleteButton,
        dialogTitle: deleteOptions?.dialogTitle,
        dialogContent: deleteOptions?.dialogContent,
        onConfirmDelete: deleteOptions?.onConfirmDelete,
      }}
    />
  );

  if (viewType === 'edit' && !record) {
    return (
      <Box py={12} px={8}>
        <Loading />
      </Box>
    );
  }

  return <TabbedForm {...baseProps} />;
};

export default CraftTabbedForm;
